import { NamespaceRelationModel } from "./NamespaceRelationModel";
import { QueueRelationGroupModel } from "./QueueRelationGroupModel";
import { QueueRelationParentTaskModel } from "./QueueRelationParentTaskModel";

/**Описание очереди */
export class QueueRelationModel {
  /**Идентификатор */
  Id: string;
  /**Имя */
  Name: string;
  /**Рабочая область, к которой принадлежит очередь */
  Namespace: NamespaceRelationModel;
  /**Список групп */
  Groups: Array<QueueRelationGroupModel> = [];
  /**Родительская задача */
  ParentTask?: QueueRelationParentTaskModel;

  constructor(obj?: Partial<QueueRelationModel>) {
    if (obj) Object.assign(this, obj);
  }
}
